'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

var _FormInput = require('../FormInput');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreCredit = (_dec = (0, _reactI18next.translate)(), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(StoreCredit, _React$Component);

  function StoreCredit() {
    (0, _classCallCheck3.default)(this, StoreCredit);
    return (0, _possibleConstructorReturn3.default)(this, (StoreCredit.__proto__ || (0, _getPrototypeOf2.default)(StoreCredit)).apply(this, arguments));
  }

  (0, _createClass3.default)(StoreCredit, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _FormInput.Field,
          { inputType: 'radio' },
          _react2.default.createElement(_FormInput.Radio, {
            name: 'useStoreCredit',
            id: 'order_payment_method_store_credit',
            value: '1',
            required: true,
            defaultChecked: true
          }),
          _react2.default.createElement(
            _FormInput.Label,
            {
              className: 'a-label a-label--large',
              htmlFor: 'order_payment_method_store_credit'
            },
            'Store Credit',
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'small',
              null,
              'Available ',
              this.props.availableStoreCredit
            )
          )
        )
      );
    }
  }]);
  return StoreCredit;
}(_react2.default.Component), _class2.propTypes = {
  availableStoreCredit: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = StoreCredit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PaymentOption/StoreCredit.js
// module id = 2305
// module chunks = 0